import styles from "./ViewNoData.module.scss";
import emptyIcon from "../../../../assets/images/noDataFound.svg";
import { ViewJobMessages } from "../constants";

const ViewNoData = () => {
  return (
    <div className={styles.emptyContainer}>
      <img src={emptyIcon} width={40} height={45} />
      <p>{ViewJobMessages.NO_DATA_FOR_SECTION}</p>
    </div>
  );
};

export default ViewNoData;
